<template>
  <main data-layout="dashboard" :class="{ ['overflow-hidden']: uploadModal }">
    <upload-modal
      v-if="uploadModal"
      :exchangeCopy="exchangeCopy"
      @closeModalclearExchangeDraft="closeModalclearExchangeDraft"
      @clearExchangeCopy="clearExchangeCopy"
    ></upload-modal>
    <fx-header></fx-header>
    <div id="dashboard-content" v-show="!loading">
      <router-view
        @reShareExchange="reShareExchange"
        @clearExchangeCopy="clearExchangeCopy"
      />
      <aside id="activity">
        <activity></activity>
      </aside>
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FxHeader from "@/components/Header";
import UploadModal from "@/views/modules/dashboard/components/file-upload/UploadModal";
import Activity from "@/views/modules/dashboard/components/activity/Activity";

export default {
  name: "Dasboard",
  components: {
    FxHeader,
    UploadModal,
    Activity
  },
  data() {
    return {
      exchangeCopy: null
    };
  },
  computed: {
    ...mapState("common", ["loading", "uploadModal"]),
    ...mapState("exchange", [
      "exchangeId",
      "rawFileCode",
      "incomingExchanges",
      "outgoingExchanges",
      "choosenFiles"
    ])
  },
  methods: {
    ...mapActions("common", [
      "closeUploadModal",
      "showUploadModal",
      "setLoading",
      "showModal"
    ]),
    ...mapActions("exchange", [
      "deleteChoosenFiles",
      "getOutgoingExchanges",
      "getIncomingExchanges",
      "deleteOutgoingExchange",
      "clearExchangeDraftFromState",
      "setChoosenFiles",
      "updateExchangeId",
      "updateExchangeCopyChoosenFiles"
    ]),
    reShareExchange(id) {
      this.setLoading(true);
      this.$store
        .dispatch("exchange/getExchangeCopy", id)
        .then(res => {
          this.exchangeCopy = res.data;
          this.updateExchangeCopyChoosenFiles(res.data.files);
          this.updateExchangeId(this.exchangeCopy.id);
          this.showUploadModal();
          this.setLoading(false);
        })
        .catch(err => {
          this.setLoading(false);
          this.showModal({
            title: err.errorCode
          });
        });
    },
    closeModalclearExchangeDraft() {
      if (this.exchangeId) {
        this.deleteOutgoingExchange(this.exchangeId);
        this.clearExchangeDraftFromState(this.exchangeId);
        this.deleteChoosenFiles();
      }
      this.exchangeCopy = null;
      this.closeUploadModal();
    },
    clearExchangeCopy() {
      this.closeUploadModal();
      this.exchangeCopy = null;
    }
  },
  created() {
    this.setLoading(true);
    if (this.rawFileCode) {
      this.setLoading(false);
      this.$router.push({ name: "rawFileDownload" });
    }
    Promise.all([
      this.closeUploadModal(),
      this.deleteChoosenFiles(),
      this.getOutgoingExchanges(),
      this.getIncomingExchanges()
    ])
      .then(() => {
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/variables";

main[data-layout="dashboard"] {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 800px;
  position: relative;
  overflow: hidden;
  #dashboard-content {
    flex: 2;
    display: flex;
  }

  aside {
    width: 30%;
    max-width: 400px;
    background: $light-gray;
    box-shadow: inset 6px 6px 5px -5px rgba(0, 0, 0, 0.15);
    border-top-left-radius: $radius;
  }
}
</style>
